import { useEffect, useState } from 'react';
import { useFilterOptions } from '../../common/hooks/useFilterOptions';
import { Filter } from '@increasecard/typed-components';
import { compareOptionsByName } from '../../utils/filtersUtils';
import { SelectMultipleField, DateField } from '@increasecard/typed-components/dist/types/Field';
import { useDispatch } from 'react-redux';
import { useShallowEqualSelector } from '../../utils/reduxUtils';
import { ReportsActions } from './actions';

export function useReportsScreen() {
  const dispatch = useDispatch();
  const reports = useShallowEqualSelector((state) => state.reports.reports);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState<Record<string, Filter>>({});
  const filterOptions = useFilterOptions();

  useEffect(() => {
    dispatch(ReportsActions.fetchStarted({ page, filters }));
  }, [page, filters, dispatch]);

  return {
    reports,
    page,
    setPage,
    filters,
    setFilters: (filters: Record<string, Filter>) => {
      setPage(1);
      setFilters(filters);
    },
    filterFields: filterOptions
      ? [
          {
            displayName: 'Tipo de reporte',
            name: 'types',
            type: 'selectMultiple',
            options: filterOptions.reportTypes
              .map(({ id, name }) => ({ value: id, name }))
              .sort(compareOptionsByName),
            hasClearButton: true
          } as SelectMultipleField,
          {
            displayName: 'Fecha de creación',
            name: 'created_at',
            type: 'date'
          } as DateField
        ]
      : []
  };
}
